/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Actionverb_Updated1Inputs */

const id_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diperbarui`)
};

const ms_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dikemas kini`)
};

const da_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opdateret`)
};

const de_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktualisiert`)
};

const en_us2_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`updated`)
};

const es_es2_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actualizado`)
};

const es_mx2_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actualizado`)
};

const fil_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`na-update`)
};

const fr_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis à jour`)
};

const it_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aggiornato`)
};

const hu_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`frissítve`)
};

const nl_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijgewerkt`)
};

const no_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oppdatert`)
};

const pl_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zaktualizowano`)
};

const pt_br2_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atualizado`)
};

const pt_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atualizado`)
};

const ro_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actualizat`)
};

const fi_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`päivitetty`)
};

const sv_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uppdaterad`)
};

const vi_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đã cập nhật`)
};

const tr_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`güncellendi`)
};

const cs_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktualizováno`)
};

const bg_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`актуализирано`)
};

const ru_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`обновлено`)
};

const uk_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`оновлено`)
};

const ar_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم التحديث`)
};

const hi_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट किया गया`)
};

const th_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตแล้ว`)
};

const ja_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新されました`)
};

const zh_cn2_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已更新`)
};

const zh_hant1_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已更新`)
};

const ko_home_pulse_actionverb_updated1 = /** @type {(inputs: Home_Pulse_Actionverb_Updated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업데이트됨`)
};

/**
* | output |
* | --- |
* | "updated" |
*
* @param {Home_Pulse_Actionverb_Updated1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_actionverb_updated1 = /** @type {((inputs?: Home_Pulse_Actionverb_Updated1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Actionverb_Updated1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_actionverb_updated1(inputs)
	if (locale === "ms") return ms_home_pulse_actionverb_updated1(inputs)
	if (locale === "da") return da_home_pulse_actionverb_updated1(inputs)
	if (locale === "de") return de_home_pulse_actionverb_updated1(inputs)
	if (locale === "en-US") return en_us2_home_pulse_actionverb_updated1(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_actionverb_updated1(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_actionverb_updated1(inputs)
	if (locale === "fil") return fil_home_pulse_actionverb_updated1(inputs)
	if (locale === "fr") return fr_home_pulse_actionverb_updated1(inputs)
	if (locale === "it") return it_home_pulse_actionverb_updated1(inputs)
	if (locale === "hu") return hu_home_pulse_actionverb_updated1(inputs)
	if (locale === "nl") return nl_home_pulse_actionverb_updated1(inputs)
	if (locale === "no") return no_home_pulse_actionverb_updated1(inputs)
	if (locale === "pl") return pl_home_pulse_actionverb_updated1(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_actionverb_updated1(inputs)
	if (locale === "pt") return pt_home_pulse_actionverb_updated1(inputs)
	if (locale === "ro") return ro_home_pulse_actionverb_updated1(inputs)
	if (locale === "fi") return fi_home_pulse_actionverb_updated1(inputs)
	if (locale === "sv") return sv_home_pulse_actionverb_updated1(inputs)
	if (locale === "vi") return vi_home_pulse_actionverb_updated1(inputs)
	if (locale === "tr") return tr_home_pulse_actionverb_updated1(inputs)
	if (locale === "cs") return cs_home_pulse_actionverb_updated1(inputs)
	if (locale === "bg") return bg_home_pulse_actionverb_updated1(inputs)
	if (locale === "ru") return ru_home_pulse_actionverb_updated1(inputs)
	if (locale === "uk") return uk_home_pulse_actionverb_updated1(inputs)
	if (locale === "ar") return ar_home_pulse_actionverb_updated1(inputs)
	if (locale === "hi") return hi_home_pulse_actionverb_updated1(inputs)
	if (locale === "th") return th_home_pulse_actionverb_updated1(inputs)
	if (locale === "ja") return ja_home_pulse_actionverb_updated1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_actionverb_updated1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_actionverb_updated1(inputs)
	return ko_home_pulse_actionverb_updated1(inputs)
});
export { home_pulse_actionverb_updated1 as "home.pulse.actionVerb.updated" }